// Autogenerated file
export const organizationTypesEnum = {
    CargoOwnerOrganization: "CargoOwnerOrganization",
    TruckingOrganization: "TruckingOrganization",
    ForwarderOrganization: "ForwarderOrganization",
};
export const organizationTypes = [
    { label: "Грузовладелец", value: "CargoOwnerOrganization", intValue: 10 },
    { label: "Транспортная компания", value: "TruckingOrganization", intValue: 20 },
    { label: "Экспедитор", value: "ForwarderOrganization", intValue: 30 },
];
